var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: "Visualizar processo - " + _vm.numeroProcesso,
        width: 1000,
        height: 700,
        bodyStyle: { height: "auto", padding: "0" }
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "modal" },
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              _vm._l(_vm.configModalVisualizarProcesso, function(item) {
                return item.show
                  ? _c(
                      "el-tab-pane",
                      {
                        key: item.name,
                        attrs: { label: item.label, name: item.name }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            item.name === "TAB_MONITORAMENTO" && item.hasIcon
                              ? _c("i", {
                                  staticClass:
                                    "fal fa fa-exclamation-triangle cor-warning"
                                })
                              : _vm._e(),
                            _c("span", [_vm._v(_vm._s(" " + item.label))])
                          ]
                        ),
                        _vm.activeTab === item.name
                          ? _c(item.component, {
                              tag: "component",
                              attrs: {
                                showBtnSegundaVia: false,
                                numeroProcesso: _vm.numeroProcesso,
                                tipoProcesso: _vm.tipo,
                                idProcesso: _vm.idProcesso,
                                protocolo: _vm.protocolo
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              }),
              1
            )
          ],
          1
        )
      ]),
      _vm.configModalVisualizarProcesso[_vm.activeTab].hasFooter
        ? _c(
            "template",
            { slot: "footer" },
            [
              _vm.configModalVisualizarProcesso[_vm.activeTab]
                .buttonConditionPdf
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-baixar-pdf",
                      attrs: { type: "default", size: "mini" },
                      on: {
                        click:
                          _vm.configModalVisualizarProcesso[_vm.activeTab]
                            .actionButtonPdf
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas",
                        class:
                          _vm.configModalVisualizarProcesso[_vm.activeTab]
                            .classIconPdf
                      }),
                      _c("b", { staticClass: "margin-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.configModalVisualizarProcesso[_vm.activeTab]
                              .textButtonPdf
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.configModalVisualizarProcesso[_vm.activeTab]
                .buttonConditionZip
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-baixar-pdf",
                      attrs: { type: "default", size: "mini" },
                      on: {
                        click:
                          _vm.configModalVisualizarProcesso[_vm.activeTab]
                            .actionButtonZip
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas",
                        class:
                          _vm.configModalVisualizarProcesso[_vm.activeTab]
                            .classIconZip
                      }),
                      _c("b", { staticClass: "margin-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.configModalVisualizarProcesso[_vm.activeTab]
                              .textButtonZip
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.configModalVisualizarProcesso[_vm.activeTab]
                .buttonConditionSolicitarCopia
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn-baixar-pdf",
                      attrs: { type: "default", size: "mini" },
                      on: {
                        click:
                          _vm.configModalVisualizarProcesso[_vm.activeTab]
                            .actionButtonCopia
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas",
                        class:
                          _vm.configModalVisualizarProcesso[_vm.activeTab]
                            .classIconPdf
                      }),
                      _c("b", { staticClass: "margin-left" }, [
                        _vm._v(
                          _vm._s(
                            _vm.configModalVisualizarProcesso[_vm.activeTab]
                              .textButtonCopia
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c5fa90f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5fa90f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalVisualizarCompleto.vue
// module id = null
// module chunks = 